/* Most ordered page, prismoon 2026-09-25.
   One script for the whole page. It runs once however many sections include it, and it queries the
   document rather than a section root, so the sections can be reordered in the editor. */
(function () {
  if (window.__agmopInit) return;
  window.__agmopInit = true;

  var BEST = window.AIRGRILLES_BEST || { types: [], home: [], commercial: [] };
  var MATRIX = window.AIRGRILLES_DISCOUNTS || {};
  var SBASE = '/search?q=*&type=product&options%5Bunavailable_products%5D=show&filter.v.availability=1';

  function money(c) { return '$' + (c / 100).toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
  function unesc(s) { var d = document.createElement('textarea'); d.innerHTML = s; return d.value; }

  /* ---------- finish and build are two different questions ---------- */
  function split(o) {
    var lab = (o.label || '').trim(), c = (o.color || '').trim();
    var build = lab;
    if (c && lab.toLowerCase().indexOf(c.toLowerCase()) === 0) build = lab.slice(c.length).replace(/^[\s,\-]+/, '');
    return { build: build || 'Standard', finish: c || 'Standard' };
  }
  function decorate(opts) {
    return (opts || []).map(function (o) { var s = split(o); return Object.assign({}, o, s); });
  }
  function uniq(list, key) {
    var seen = {}, out = [];
    list.forEach(function (x) { if (!seen[x[key]]) { seen[x[key]] = 1; out.push(x[key]); } });
    return out;
  }
  function firstLive(opts) { return opts.filter(function (o) { return o.avail; })[0] || opts[0]; }

  /* ---------- price: three shapes, decided by the data and nothing else ----------
     a real ladder -> the four band table
     every band the same discount (max5 today) -> one line that names the percentage
     no profile at all -> Special Price, the same money at any count, exactly as the quick order
     tables and the product pages say it. If the discount matrix changes, the shape changes with it. */
  function bands(profile, cents) {
    var b = MATRIX[profile];
    if (!b || profile === 'max0' || !profile) return [];
    return b.filter(function (x) { return (x.min_qty | 0) > 1; }).slice(0, 4).map(function (x) {
      return { min: x.min_qty, max: x.max_qty, off: x.discount,
               price: cents - Math.floor(cents * x.discount / 100) };
    });
  }
  function tierIndex(rows, qty) {
    for (var i = rows.length - 1; i >= 0; i--) if (qty >= rows[i].min) return i;
    return -1;
  }
  function bandLabel(r) { return r.max && r.max !== r.min ? r.min + '-' + r.max : r.min + '+'; }
  function priceBlock(o, qty) {
    var rows = bands(o.profile, o.cents);
    var head = '<div class="agmop__vol"><span class="agmop__label">Unit price by quantity</span>';
    if (!rows.length) {
      return head + '<p class="agmop__flat"><span class="agmop__flag">Special price</span>' +
        '<span>' + money(o.cents) + ' each at any count. Ordering 50 or more? Ask for a quote.</span></p></div>';
    }
    var flat = rows.every(function (r) { return r.price === rows[0].price; });
    if (flat) {
      var pct = Math.round(rows[0].off);
      return head + '<p class="agmop__flat"><span class="agmop__flag">' + pct + '% off from ' + rows[0].min + '</span>' +
        '<span>' + money(rows[0].price) + ' each once you take ' + rows[0].min + ' or more, at any count above that.</span></p></div>';
    }
    var on = tierIndex(rows, qty);
    return head + '<div class="agmop__volgrid">' + rows.map(function (r, i) {
      return '<div class="agmop__volcell' + (i === on ? ' is-on' : '') + '">' +
        '<span class="agmop__volqty">' + bandLabel(r) + '</span>' +
        '<span class="agmop__volprice">' + money(r.price) + '</span></div>';
    }).join('') + '</div></div>';
  }
  function nextLine(o, qty) {
    var rows = bands(o.profile, o.cents);
    if (rows.length < 2) return '';
    var on = tierIndex(rows, qty), now = on < 0 ? o.cents : rows[on].price;
    for (var i = on + 1; i < rows.length; i++) {
      if (rows[i].price < now) {
        return '<p class="agmop__next">Add ' + (rows[i].min - qty) + ' more to reach ' + money(rows[i].price) + ' each.</p>';
      }
    }
    return '';
  }
  function unitAt(o, qty) {
    var rows = bands(o.profile, o.cents), i = tierIndex(rows, qty);
    return i < 0 ? o.cents : rows[i].price;
  }
  function swatch(name) {
    var n = (name || '').toLowerCase();
    if (n.indexOf('white') > -1) return '#ffffff';
    if (n.indexOf('black') > -1) return '#1a1a1a';
    if (n.indexOf('brown') > -1) return '#5b3a22';
    if (n.indexOf('brass') > -1) return '#b5892f';
    if (n.indexOf('nickel') > -1 || n.indexOf('chrome') > -1 || n.indexOf('silver') > -1) return '#c2c8cc';
    if (n.indexOf('bronze') > -1 || n.indexOf('copper') > -1) return '#7a4a27';
    if (n.indexOf('light gray') > -1 || n.indexOf('light grey') > -1) return '#c9ced2';
    if (n.indexOf('dark gray') > -1 || n.indexOf('dark grey') > -1) return '#4d545a';
    if (n.indexOf('gray') > -1 || n.indexOf('grey') > -1) return '#8e969c';
    if (n.indexOf('oak') > -1 || n.indexOf('wood') > -1 || n.indexOf('maple') > -1) return '#b98b52';
    if (n.indexOf('ivory') > -1 || n.indexOf('almond') > -1) return '#efe6d2';
    return '#dbe2e7';
  }
  function stars(rev) {
    if (!rev || !rev.n) return '';
    var pct = Math.max(0, Math.min(5, rev.avg)) * 20;
    return '<span class="agmop__stars"><span class="agmop__starbar" style="--agmop-pct:' + pct + '%" ' +
      'role="img" aria-label="' + rev.avg + ' out of 5"></span>' + rev.avg + ' (' + rev.n + ')</span>';
  }
  function quoteBtn(o, title) {
    return '<button type="button" class="agmop__quote" data-airgrilles-qo3-quote' +
      ' data-product-title="' + esc(title || '') + '"' +
      ' data-product-url="/products/' + esc(o.handle) + '"' +
      ' data-variant-id="' + esc(o.id) + '"' +
      ' data-item-no="' + esc(o.item || '') + '">Get quote</button>';
  }
  // The theme keeps its cart helpers inside theme.js (halo.updateSidebarCart), out of reach, and it does not
  // listen for 'cart:refresh'. So after our own /cart/add.js we do what that helper does: set every
  // [data-cart-count], re-render the side cart through jQuery (its inline script has to run), and then
  // follow the store's after-add setting the way a product page does.
  function syncThemeCart(open) {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        [].forEach.call(document.querySelectorAll('[data-cart-count]'), function (el) { el.textContent = cart.item_count; });
        var box = document.querySelector('#halo-cart-sidebar .previewCart-wrapper');
        if (!box) return;
        return fetch('/cart?view=ajax_side_cart&_=' + Date.now(), { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            if (window.jQuery) window.jQuery(box).html(html); else box.innerHTML = html;
            if (open) document.body.classList.add('cart-sidebar-show');
          });
      })
      .catch(function () {});
  }
  function addToCart(items, btn) {
    var was = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        var after = window.after_add_to_cart || {}, quick = window.quick_cart || {};
        if (after.type === 'cart' || (after.type === 'quick_cart' && !quick.show)) {
          window.location.href = (window.routes && window.routes.cart) || '/cart';
          return;
        }
        if (btn) btn.textContent = 'Added';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        syncThemeCart(after.type === 'quick_cart');
        if (btn) setTimeout(function () { btn.disabled = false; btn.textContent = was; }, 1600);
      })
      .catch(function (err) {
        // 422 (sold out, more than in stock): Shopify's own sentence in the theme's warning popup
        var msg = err && err.description;
        if (btn) { btn.disabled = false; btn.textContent = msg ? was : 'Try again'; }
        if (msg && typeof window.showWarning === 'function') window.showWarning(msg, 5000);
        syncThemeCart(false);
      });
  }

  /* ---------- image viewer ---------- */
  var lb;
  function lightbox() {
    if (lb) return lb;
    lb = document.createElement('div');
    lb.className = 'agmop-lb';
    lb.innerHTML = '<div class="agmop-lb__box"><p class="agmop-lb__title"></p>' +
      '<button type="button" class="agmop-lb__close" aria-label="Close">&times;</button>' +
      '<div class="agmop-lb__thumbs"></div><div class="agmop-lb__stage"><img alt=""></div>' +
      '<a class="agmop-lb__view" href="#">View product</a></div>';
    document.body.appendChild(lb);
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.closest('.agmop-lb__close')) { closeLb(); return; }
      var t = e.target.closest('[data-agmop-lbthumb]');
      if (t) {
        lb.querySelector('.agmop-lb__stage img').src = t.dataset.agmopLbthumb;
        lb.querySelectorAll('[data-agmop-lbthumb]').forEach(function (x) { x.classList.toggle('is-on', x === t); });
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLb(); });
    return lb;
  }
  function closeLb() { if (lb) { lb.classList.remove('is-open'); document.body.style.overflow = ''; } }
  function openLb(handle, title, instant) {
    var box = lightbox();
    var stage = box.querySelector('.agmop-lb__stage img');
    var thumbs = box.querySelector('.agmop-lb__thumbs');
    box.querySelector('.agmop-lb__title').textContent = title || '';
    box.querySelector('.agmop-lb__view').href = '/products/' + handle;
    thumbs.innerHTML = '';
    stage.src = instant || '';
    box.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    // the gallery is read from the product itself, so nothing here can go stale against the shop
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var imgs = (p.images || []).slice(0, 8);
        if (!imgs.length) return;
        stage.src = imgs[0] + '&width=1200';
        thumbs.innerHTML = imgs.map(function (u, i) {
          return '<button type="button" class="agmop-lb__thumb' + (i ? '' : ' is-on') + '" ' +
            'data-agmop-lbthumb="' + esc(u) + '&width=1200"><img src="' + esc(u) + '&width=140" alt=""></button>';
        }).join('');
      })
      .catch(function () {});
  }

  /* ---------- the family card ---------- */
  function pickUrl(sub, size) {
    var u = SBASE + '&filter.p.m.custom.subcategory=' + encodeURIComponent(sub);
    if (size.indexOf(' x ') > -1) {
      var wh = size.split(' x ');
      u += '&filter.p.m.custom.width=' + encodeURIComponent(wh[0]) + '&filter.p.m.custom.height=' + encodeURIComponent(wh[1]);
    } else {
      u += '&filter.p.m.custom.neck_size=' + encodeURIComponent(size);
    }
    return u;
  }
  // the pick endpoint writes a tier as "2-10=1045=5": the band, the price in cents, the percent.
  // Reading it with the wrong separator produced a NaN discount and a ladder of $NaN.
  function profileOf(tier) {
    if (!tier) return 'max0';
    var key = 'live-' + tier.length + '-' + tier.slice(0, 16);
    var rows = tier.split(',').filter(Boolean).map(function (t) {
      var p = t.split('=');
      var span = (p[0] || '').replace('+', '').split('-');
      return { min_qty: parseInt(span[0], 10),
               max_qty: span[1] ? parseInt(span[1], 10) : null,
               discount: parseFloat(p[2]) };
    }).filter(function (x) { return x.min_qty && !isNaN(x.discount); });
    if (!rows.length) return 'max0';
    MATRIX[key] = rows;
    return key;
  }
  /* ---------- live family feed ----------
     The seed (mop-data.js) is a periodic snapshot: it carries the ranking, the popular sizes and the
     labels. Price, stock and the picture must come from the shop as it is right now, so each family
     is read once from its own collection (accurate index, one small answer) and every option on the
     card is patched from it. Size changes then filter that same answer, with no trip to /search. */
  var LIVE_SECTION = 'airgrilles-live-prismoon';
  var FAM = {};
  var HINT = /(\d+-(?:Slot|Way|Cone)|Adjustable|Curved Blade|Fixed|Eggcrate|Perforated|Plaque)/i;
  function liveLabel(r) {
    var lab = r.color || 'Standard';
    var m = HINT.exec(r.title || '');
    if (m) lab += ' ' + m[1];
    if (r.neck) lab += ' ' + r.neck;
    if (r.air) lab += ' ' + r.air.split(' ')[0];
    return lab;
  }
  function familyRows(coll) {
    if (!coll) return Promise.resolve(null);
    if (FAM[coll]) return FAM[coll];
    FAM[coll] = fetch('/collections/' + coll + '?section_id=' + LIVE_SECTION)
      .then(function (r) { return r.text(); })
      .then(function (txt) {
        var a = txt.indexOf('{'), b = txt.lastIndexOf('}');
        var d = JSON.parse(txt.slice(a, b + 1));
        return (d.rows || []).filter(Boolean).map(function (row) {
          var f = row.split('^').map(unesc);
          var r = { handle: f[0], id: f[1], cents: parseInt(f[2], 10), avail: f[3] === '1' ? 1 : 0, img: f[4],
                    profile: f[5] || 'max0', w: f[6], h: f[7], color: f[8], item: f[9], neck: f[10], air: f[11],
                    title: f[12], rev: null };
          r.size = r.w && r.h ? r.w + ' x ' + r.h : (r.neck || '');
          r.label = liveLabel(r);
          return r;
        });
      })
      .catch(function () { FAM[coll] = null; return null; });
    return FAM[coll];
  }
  // seed options keep their curated labels and review data; only the volatile fields move
  function mergeLive(seedOpts, liveRows, size) {
    var at = liveRows.filter(function (r) { return r.size === size; });
    if (!at.length) return null;
    var byHandle = {};
    at.forEach(function (r) { byHandle[r.handle] = r; });
    var out = (seedOpts || []).map(function (o) {
      var r = byHandle[o.handle];
      if (!r) return null;
      delete byHandle[o.handle];
      return Object.assign({}, o, { cents: r.cents, avail: r.avail, img: r.img || o.img, profile: r.profile || o.profile, id: r.id || o.id });
    }).filter(Boolean);
    Object.keys(byHandle).forEach(function (h) { out.push(byHandle[h]); });
    return decorate(out);
  }
  function applyLive(card) {
    if (card._liveDone) return;
    card._liveDone = true;
    var src = card.dataset.source, idx = parseInt(card.dataset.index, 10);
    var seed = src === 'tbar' ? BEST.commercial[idx] : BEST.types[idx];
    if (!seed || !seed.coll) return;
    familyRows(seed.coll).then(function (rows) {
      if (!rows || !rows.length) return;
      card._fam = rows;
      var st = card._st;
      var merged = mergeLive(card._opts, rows, st.size);
      if (!merged) return;
      var keep = merged.filter(function (o) { return o.build === st.build && o.finish === st.finish; })[0];
      card._opts = merged;
      if (!keep || !keep.avail) { var s0 = firstLive(merged); st.build = s0.build; st.finish = s0.finish; }
      drawCard(card);
    });
  }
  var liveWatch = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { applyLive(e.target); liveWatch.unobserve(e.target); } });
  }, { rootMargin: '400px 0px' }) : null;

  function fetchSize(sub, size) {
    return fetch(pickUrl(sub, size) + '&section_id=airgrilles-pick-prismoon')
      .then(function (r) { return r.text(); })
      .then(function (txt) {
        var a = txt.indexOf('{'), b = txt.lastIndexOf('}');
        var d = JSON.parse(txt.slice(a, b + 1));
        return decorate((d.rows || []).filter(Boolean).map(function (row) {
          var f = row.split('^');
          return { handle: f[0], id: f[1], cents: parseInt(f[2], 10), color: f[3], label: f[3] || 'Standard',
                   item: f[4], avail: f[5] === 'y' ? 1 : 0, img: f[6], profile: profileOf(f[7]), rev: null };
        }));
      });
  }
  function reconcile(st, opts) {
    var byBuild = opts.filter(function (o) { return o.build === st.build; });
    if (!byBuild.length) { st.build = opts[0].build; byBuild = opts.filter(function (o) { return o.build === st.build; }); }
    var hit = byBuild.filter(function (o) { return o.finish === st.finish; })[0];
    if (!hit) { var live = byBuild.filter(function (o) { return o.avail; })[0]; st.finish = (live || byBuild[0]).finish; }
    return byBuild.filter(function (o) { return o.finish === st.finish; })[0] || byBuild[0];
  }
  // "Build" said nothing. Name the axis the family actually varies on.
  function buildLabel(builds) {
    var j = builds.join(' | ');
    if (/latch/i.test(j)) return 'Latch type';
    if (/\d+-way/i.test(j) && builds.every(function (b) { return /\d+-way/i.test(b); })) return 'Airflow pattern';
    if (/neck/i.test(j)) return 'Neck size';
    if (/\d+-cone|plaque|perforated/i.test(j)) return 'Face type';
    return 'Style';
  }
  function finBtn(x, st) {
    return '<button type="button" class="agmop__fin' + (x.finish === st.finish ? ' is-on' : '') + '"' +
      (x.avail ? '' : ' disabled') + ' data-agmop-fin="' + esc(x.finish) + '" title="' + esc(x.label) +
      (x.avail ? '' : ' - out of stock') + '">' +
      '<span class="agmop__dot" style="background:' + swatch(x.color || x.finish) + '"></span>' + esc(x.finish) + '</button>';
  }
  function drawCard(card) {
    var st = card._st, opts = card._opts;
    var opt = card.querySelector('[data-agmop-opt]');
    var foot = card.querySelector('[data-agmop-foot]');
    var name = card.querySelector('h3[data-agmop-title]');  // the photo button carries the attribute too, and comes first
    if (!opts || !opts.length) {
      opt.innerHTML = sizeField(card, st);
      foot.innerHTML = '<p class="agmop__miss">Nothing in stock at ' + esc(st.size.replace(/"/g, '')) +
        ' today. <a href="' + esc(card.dataset.table) + '">See every size in this family</a>.</p>';
      card.querySelector('[data-agmop-sel]').innerHTML = '';
      return;
    }
    var o = reconcile(st, opts);
    card._current = o;
    var builds = uniq(opts, 'build');
    var fins = opts.filter(function (x) { return x.build === st.build; });
    var live = fins.filter(function (x) { return x.avail; });
    var dead = fins.filter(function (x) { return !x.avail; });

    var html = '';
    if (fins.length > 1) {
      html += '<div><span class="agmop__label">Finish</span><div class="agmop__fins">' +
        live.map(function (x) { return finBtn(x, st); }).join('') +
        dead.map(function (x) { return finBtn(x, st); }).join('') + '</div></div>';
    }
    if (builds.length > 1) {
      html += '<div><span class="agmop__label">' + buildLabel(builds) + '</span><select class="agmop__select" data-agmop-build>' +
        builds.map(function (b) {
          var any = opts.some(function (x) { return x.build === b && x.avail; });
          return '<option value="' + esc(b) + '"' + (b === st.build ? ' selected' : '') + '>' +
            esc(b) + (any ? '' : ' (out of stock)') + '</option>';
        }).join('') + '</select></div>';
    }
    html += sizeField(card, st);
    opt.innerHTML = html;

    card.querySelector('[data-agmop-sel]').innerHTML =
      '<p class="agmop__selname">' + esc(o.finish) + (o.build && o.build !== 'Standard' ? ', ' + esc(o.build.toLowerCase()) : '') + '</p>' +
      '<p class="agmop__meta">Item ' + esc(o.item || '') + ' &middot; <span class="agmop__stock' +
      (o.avail ? '' : ' is-out') + '">' + (o.avail ? 'In stock' : 'Out of stock') + '</span></p>' +
      '<p class="agmop__price">' + money(o.cents) + ' <span>each</span></p>' +
      (stars(o.rev) ? '<p class="agmop__meta">' + stars(o.rev) + '</p>' : '');

    foot.innerHTML = priceBlock(o, st.qty) +
      '<div class="agmop__buy"><span class="agmop__qty">' +
        '<button type="button" class="agmop__step" data-agmop-step="-1" aria-label="Fewer">&minus;</button>' +
        '<input class="agmop__num" type="number" min="1" value="' + st.qty + '" aria-label="Quantity">' +
        '<button type="button" class="agmop__step" data-agmop-step="1" aria-label="More">+</button></span>' +
        '<button type="button" class="agmop__add" data-agmop-add' + (o.avail ? '' : ' disabled') + '>' +
        (o.avail ? 'Add to cart' : 'Out of stock') + '</button>' +
        quoteBtn(o, (name ? name.textContent : '') + ' ' + st.size) + '</div>' +
      nextLine(o, st.qty);

    var shot = card.querySelector('[data-agmop-shot]');
    if (shot && o.img) { shot.src = o.img + '?width=560'; shot.closest('[data-agmop-zoom]').dataset.handle = o.handle; }
  }
  function sizeField(card, st) {
    var all = unesc(card.dataset.allsizes || '').split(';').filter(Boolean);
    var pop = unesc(card.dataset.popsizes || '').split(';').filter(Boolean);
    if (!all.length && !pop.length) return '';
    var out = '<div><span class="agmop__label">Duct opening size, W x H</span><div class="agmop__sizes">' +
      pop.slice(0, 6).map(function (row) {
        var p = row.split('='), sz = p[0], gone = p[1] === '0';
        return '<button type="button" class="agmop__size' + (sz === st.size ? ' is-on' : '') + (gone ? ' is-out' : '') +
          '" data-agmop-size="' + esc(sz) + '">' + esc(sz.replace(/"/g, '')) +
          (gone ? '<span class="agmop__outtag">Sold out</span>' : '') + '</button>';
      }).join('') + '</div>';
    if (all.length > 1) {
      out += '<span class="agmop__label" style="margin-top:10px">Or pick from all ' + all.length + ' sizes</span>' +
        '<select class="agmop__select" data-agmop-allsize style="margin-top:6px">' +
        '<option value="">Choose a size</option>' +
        all.map(function (row) {
          var p = row.split('='), sz = p[0], gone = p[1] === '0';
          return '<option value="' + esc(sz) + '"' + (sz === st.size ? ' selected' : '') + '>' +
            esc(sz.replace(/"/g, '')) + (gone ? ' - sold out' : '') + '</option>';
        }).join('') + '</select>';
    }
    return out + '</div>';
  }

  function loadSize(card, size) {
    var st = card._st;
    st.size = size;
    var opt = card.querySelector('[data-agmop-opt]');
    card.querySelector('[data-agmop-foot]').innerHTML =
      '<p class="agmop__miss">Loading ' + esc(size.replace(/"/g, '')) + '...</p>';
    var seed = BEST.types[card.dataset.index | 0];
    if (card._fam) {
      var base = (seed && seed.size === size && card.dataset.source !== 'tbar') ? decorate(seed.options) : [];
      var merged = mergeLive(base, card._fam, size) || [];
      card._opts = merged;
      var f1 = firstLive(merged);
      if (f1) { st.build = f1.build; st.finish = f1.finish; }
      drawCard(card);
      return;
    }
    if (seed && seed.size === size && card.dataset.source !== 'tbar') {
      card._opts = decorate(seed.options);
      var s0 = firstLive(card._opts); st.build = s0.build; st.finish = s0.finish;
      drawCard(card);
      return;
    }
    fetchSize(card.dataset.sub, size)
      .then(function (opts) {
        card._opts = opts;
        var f0 = firstLive(opts);
        if (f0) { st.build = f0.build; st.finish = f0.finish; }
        drawCard(card);
      })
      .catch(function () {
        card.querySelector('[data-agmop-foot]').innerHTML =
          '<p class="agmop__miss"><a href="' + esc(card.dataset.table) + '">Open the full size table</a></p>';
      });
  }

  function initCards() {
    document.querySelectorAll('[data-agmop-card]').forEach(function (card) {
      if (card._opts) return;
      var src = card.dataset.source, idx = parseInt(card.dataset.index, 10);
      var seed = src === 'tbar' ? BEST.commercial[idx] : BEST.types[idx];
      if (!seed || !seed.options || !seed.options.length) return;
      card._st = { size: seed.size, build: null, finish: null, qty: 1 };
      card._opts = decorate(seed.options);
      var s0 = firstLive(card._opts);
      card._st.build = s0.build; card._st.finish = s0.finish;
      drawCard(card);
      // a family whose best selling size is sold out in every finish must not open on a dead button
      if (!card._opts.some(function (o) { return o.avail; })) {
        var pop = unesc(card.dataset.popsizes || '').split(';').filter(Boolean);
        var live = pop.filter(function (r) { return r.split('=')[1] !== '0'; })[0];
        if (live) loadSize(card, live.split('=')[0]);
      }
      if (liveWatch) liveWatch.observe(card); else applyLive(card);
    });
  }

  /* ---------- the order sheet ---------- */
  var ROLE = ['Wall and ceiling supply', 'Return with filter', 'Floor supply', 'Baseboard return'];
  var SHEET = (BEST.home || []).map(function (row, i) {
    var fams = [{ label: row.label, sub: row.sub, coll: row.coll, sizes: row.sizes || [], options: decorate(row.options) }].concat(
      (row.alts || []).map(function (a) {
        return { label: a.label, sub: a.sub, coll: a.coll, sizes: a.sizes || [], options: decorate(a.options) };
      }));
    var builds = [];
    fams.forEach(function (fam) {
      var order = [], byBuild = {};
      fam.options.forEach(function (o) {
        if (!byBuild[o.build]) { byBuild[o.build] = []; order.push(o.build); }
        byBuild[o.build].push(o);
      });
      order.forEach(function (b) {
        builds.push({ label: b === 'Standard' ? fam.label : fam.label + ', ' + b.toLowerCase(),
                      sub: fam.sub, coll: fam.coll, sizes: fam.sizes, options: byBuild[b] });
      });
    });
    return { role: ROLE[i] || row.label, size: row.size, qty: row.qty || 1, on: true,
             build: 0, finish: null, builds: builds, loading: false };
  });
  function finList(opts) {
    var seen = {}, out = [];
    opts.forEach(function (o) {
      var k = o.finish.toLowerCase();
      if (!seen[k]) { seen[k] = o; out.push(o); return; }
      if (!seen[k].avail && o.avail) { out[out.indexOf(seen[k])] = o; seen[k] = o; }
    });
    return out;
  }
  function sheetPick(line) {
    var opts = finList(line.builds[line.build].options);
    if (!opts.length) return null;
    var hit = opts.filter(function (o) { return o.finish === line.finish; })[0];
    if (!hit) { hit = opts.filter(function (o) { return o.avail; })[0] || opts[0]; line.finish = hit.finish; }
    return hit;
  }
  function drawSheet() {
    var rows = document.querySelector('[data-agmop-sheetrows]');
    if (!rows) return;
    rows.innerHTML = SHEET.map(function (line, i) {
      var b = line.builds[line.build];
      var o = sheetPick(line);
      if (!o) {
        return '<div class="agmop__row" data-agmop-line="' + i + '"><div class="agmop__rowid">' +
          '<div><span class="agmop__role">' + esc(line.role) + '</span>' +
          '<p class="agmop__rowname">' + esc(b.label) + '</p></div></div>' +
          '<p class="agmop__miss">Nothing in stock at ' + esc(line.size.replace(/"/g, '')) + ' in this build.</p></div>';
      }
      var fins = finList(b.options);
      var unit = unitAt(o, line.qty);
      var sizes = (b.sizes || []).filter(Boolean);
      return '<div class="agmop__row' + (line.on ? '' : ' is-off') + '" data-agmop-line="' + i + '">' +
        '<div class="agmop__rowid">' +
          '<input class="agmop__tick" type="checkbox" data-agmop-tick' + (line.on ? ' checked' : '') +
            ' aria-label="Include ' + esc(line.role) + '">' +
          '<button type="button" class="agmop__rowshot" data-agmop-zoom data-handle="' + esc(o.handle) + '" ' +
            'data-title="' + esc(b.label) + '" aria-label="Enlarge"><img src="' + esc(o.img) + '?width=160" alt=""></button>' +
          '<div><span class="agmop__role">' + esc(line.role) + '</span>' +
            '<p class="agmop__rowname">' + esc(b.label) + '</p>' +
            '<p class="agmop__rowmeta">Item ' + esc(o.item || '') + ' &middot; ' + (o.avail ? 'In stock' : 'Out of stock') + '</p>' +
            (stars(o.rev) ? '<p class="agmop__rowmeta">' + stars(o.rev) + '</p>' : '') +
          '</div>' +
        '</div>' +
        '<div class="agmop__rowopts">' +
          '<span class="agmop__label">Build</span>' +
          (line.builds.length > 1
            ? '<select class="agmop__select" data-agmop-sbuild>' + line.builds.map(function (x, bi) {
                return '<option value="' + bi + '"' + (bi === line.build ? ' selected' : '') + '>' + esc(x.label) + '</option>';
              }).join('') + '</select>'
            : '<p class="agmop__only">' + esc(b.label) + '</p>') +
          '<span class="agmop__label">Duct opening</span>' +
          (sizes.length > 1
            ? '<select class="agmop__select" data-agmop-ssize>' + sizes.map(function (row2) {
                var p = row2.split('='), sz = p[0], gone = p[1] === '0';
                return '<option value="' + esc(sz) + '"' + (sz === line.size ? ' selected' : '') + '>' +
                  esc(sz.replace(/"/g, '')) + (gone ? ' - sold out' : '') + '</option>';
              }).join('') + '</select>'
            : '<p class="agmop__only">' + esc(line.size.replace(/"/g, '')) + '</p>') +
          (fins.length > 1
            ? '<span class="agmop__label">Finish</span><select class="agmop__select" data-agmop-sfin>' +
              fins.map(function (x) {
                return '<option value="' + esc(x.finish) + '"' + (x.finish === line.finish ? ' selected' : '') + '>' +
                  esc(x.finish) + (x.avail ? '' : ' (out of stock)') + '</option>';
              }).join('') + '</select>'
            : '<span class="agmop__label">Finish</span><p class="agmop__only">' + esc(o.finish) + '</p>') +
        '</div>' +
        priceBlock(o, line.qty) +
        '<div><span class="agmop__label">Count</span>' +
          '<span class="agmop__qty"><button type="button" class="agmop__step" data-agmop-sstep="-1" aria-label="Fewer">&minus;</button>' +
          '<input class="agmop__num" type="number" min="1" value="' + line.qty + '" data-agmop-snum aria-label="Count">' +
          '<button type="button" class="agmop__step" data-agmop-sstep="1" aria-label="More">+</button></span></div>' +
        '<div class="agmop__linewrap"><span class="agmop__label">Line total</span>' +
          '<p class="agmop__linetotal">' + money(unit * line.qty) + '</p>' +
          '<button type="button" class="agmop__rowadd" data-agmop-rowadd' + (o.avail ? '' : ' disabled') + '>Add this one</button></div>' +
      '</div>';
    }).join('');
    sheetTotals();
  }
  function sheetTotals() {
    var cents = 0, pieces = 0, lines = 0;
    SHEET.forEach(function (line) {
      if (!line.on) return;
      var o = sheetPick(line);
      if (!o) return;
      cents += unitAt(o, line.qty) * line.qty;
      pieces += line.qty; lines += 1;
    });
    var all = SHEET.reduce(function (n, l) { return n + l.qty; }, 0);
    var t = document.querySelector('[data-agmop-total]');
    if (!t) return;
    t.textContent = money(cents);
    document.querySelector('[data-agmop-sheetcount]').textContent = all + ' vents across ' + SHEET.length + ' items';
    document.querySelector('[data-agmop-footcount]').textContent = lines + ' items, ' + pieces + ' vents included';
    var btn = document.querySelector('[data-agmop-addall]');
    btn.disabled = lines === 0;
    btn.textContent = lines === 0 ? 'Nothing selected' : 'Add ' + pieces + ' vents to cart';
  }
  function liveSheet() {
    SHEET.forEach(function (line) {
      line.builds.forEach(function (b) {
        if (!b.coll) return;
        familyRows(b.coll).then(function (rows) {
          if (!rows || !rows.length) return;
          b.fam = rows;
          var merged = mergeLive(b.options, rows, line.size);
          if (merged) { b.options = merged.filter(function (o) { return o.build === b.options[0].build; }); if (!b.options.length) b.options = merged; }
          drawSheet();
        });
      });
    });
  }
  function reloadLine(line, size) {
    var b = line.builds[line.build];
    line.size = size;
    if (b.fam) {
      var merged = mergeLive([], b.fam, size) || [];
      var same = merged.filter(function (o) { return o.build === (b.options[0] || {}).build; });
      b.options = same.length ? same : merged;
      line.finish = null;
      drawSheet();
      return;
    }
    if (!b.sub) { drawSheet(); return; }
    fetchSize(b.sub, size).then(function (opts) {
      b.options = opts.filter(function (o) { return o.build === b.options[0].build; });
      if (!b.options.length) b.options = opts;
      line.finish = null;
      drawSheet();
    }).catch(function () { drawSheet(); });
  }

  /* ---------- wiring ---------- */
  document.addEventListener('click', function (e) {
    var zoom = e.target.closest('[data-agmop-zoom]');
    if (zoom) {
      e.preventDefault();
      openLb(zoom.dataset.handle, zoom.dataset.title || '', (zoom.querySelector('img') || {}).currentSrc);
      return;
    }
    var card = e.target.closest('[data-agmop-card]');
    if (card) {
      var size = e.target.closest('[data-agmop-size]');
      if (size) { loadSize(card, unesc(size.dataset.agmopSize)); return; }
      var fin = e.target.closest('[data-agmop-fin]');
      if (fin) { card._st.finish = unesc(fin.dataset.agmopFin); drawCard(card); return; }
      var step = e.target.closest('[data-agmop-step]');
      if (step) { card._st.qty = Math.max(1, card._st.qty + parseInt(step.dataset.agmopStep, 10)); drawCard(card); return; }
      var add = e.target.closest('[data-agmop-add]');
      if (add && card._current) { addToCart([{ id: card._current.id, quantity: card._st.qty }], add); return; }
    }
    var row = e.target.closest('[data-agmop-line]');
    if (row) {
      var line = SHEET[parseInt(row.dataset.agmopLine, 10)];
      var ss = e.target.closest('[data-agmop-sstep]');
      if (ss) { line.qty = Math.max(1, line.qty + parseInt(ss.dataset.agmopSstep, 10)); drawSheet(); return; }
      var ra = e.target.closest('[data-agmop-rowadd]');
      if (ra) { var o = sheetPick(line); if (o) addToCart([{ id: o.id, quantity: line.qty }], ra); return; }
    }
    var all = e.target.closest('[data-agmop-addall]');
    if (all) {
      var items = [];
      SHEET.forEach(function (l) { if (!l.on) return; var x = sheetPick(l); if (x && x.avail) items.push({ id: x.id, quantity: l.qty }); });
      if (items.length) addToCart(items, all);
    }
  });

  document.addEventListener('change', function (e) {
    var card = e.target.closest('[data-agmop-card]');
    if (card) {
      if (e.target.matches('[data-agmop-build]')) { card._st.build = e.target.value; drawCard(card); return; }
      if (e.target.matches('[data-agmop-allsize]') && e.target.value) { loadSize(card, unesc(e.target.value)); return; }
    }
    var row = e.target.closest('[data-agmop-line]');
    if (!row) return;
    var line = SHEET[parseInt(row.dataset.agmopLine, 10)];
    if (e.target.matches('[data-agmop-sbuild]')) {
      line.build = parseInt(e.target.value, 10); line.finish = null;
      var b = line.builds[line.build];
      var has = (b.sizes || []).some(function (r) { return r.split('=')[0] === line.size; });
      if (has && b.sub) { reloadLine(line, line.size); } else { drawSheet(); }
      return;
    }
    if (e.target.matches('[data-agmop-ssize]')) { reloadLine(line, unesc(e.target.value)); return; }
    if (e.target.matches('[data-agmop-sfin]')) { line.finish = e.target.value; drawSheet(); return; }
    if (e.target.matches('[data-agmop-tick]')) { line.on = e.target.checked; drawSheet(); return; }
  });

  document.addEventListener('input', function (e) {
    var card = e.target.closest('[data-agmop-card]');
    if (card && e.target.matches('.agmop__num')) {
      card._st.qty = Math.max(1, parseInt(e.target.value, 10) || 1);
      var o = card._current;
      if (!o) return;
      var vol = card.querySelector('.agmop__vol');
      if (vol) vol.outerHTML = priceBlock(o, card._st.qty);
      var nx = card.querySelector('.agmop__next'), html = nextLine(o, card._st.qty);
      if (nx) { if (html) nx.outerHTML = html; else nx.remove(); }
      else if (html) card.querySelector('.agmop__buy').insertAdjacentHTML('afterend', html);
      return;
    }
    var row = e.target.closest('[data-agmop-line]');
    if (row && e.target.matches('[data-agmop-snum]')) {
      SHEET[parseInt(row.dataset.agmopLine, 10)].qty = Math.max(1, parseInt(e.target.value, 10) || 1);
      drawSheet();
    }
  });

  function boot() { initCards(); drawSheet(); liveSheet(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
